import {apiRequest, ApiResponse} from "@/data/api/portal"

export interface Env {"id": string;"title": string}

export interface App {id: string; title: string}

export interface AppInstance {
  env: string;
  id: string;
  title: string;
  version: string;
  buildDate: string;
  status: string;
  buildTimestamp: string;
  startupTimestamp: string;
}
export interface MTEnvResponse {
  envs: Env[];
  apps: App[];
  instances: AppInstance[];
}

export async function getMTEnvironments(): Promise<ApiResponse<MTEnvResponse>> {
  return apiRequest("/mtEnvironments")
}

export async function mtEnvUpgrade(app: string, env: string): Promise<ApiResponse<{}>> {
  return apiRequest("/mtUpgrade", {app, env}, "post")
}
